
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[categoryId]",
      function () {
        return require("private-next-pages/products/[categoryId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[categoryId]"])
      });
    }
  